import Enhancer from '../enhancer';
import EnhancerApp from '../enhancer-app';

export default class NavPane extends Enhancer {
    animationDelay = 0;
    backdropAnimationDelay = 100;
    opener = null;
    isShown = false;
    scrollbarWidth = 0;
    bodyIsOverflowing = null;
    handleClickOutsideBind = null;
    handleEscKeyBind = null;
    handleTabKeyBind = null;
    buttonText = null;

    init() {
        this.openers.forEach((opener) => {
            opener.addEventListener('click', this.show.bind(this), true);
        });
    }

    show(e) {
        this.opener = e.currentTarget;

        if (this.isShown) {
            this.hide(e);
            return;
        }

        this.opener.setAttribute('aria-expanded', 'true');

        this.wrapper.style.display = 'block';
        this.wrapper.setAttribute('aria-hidden', false);

        setTimeout(() => {
            document.querySelector('body').classList.add('nav-pane-open');

            this.wrapper.focus();
        }, this.animationDelay);

        // Hide on click outside
        this.handleClickOutsideBind = this.handleClickOutside.bind(this);
        this.wrapper.addEventListener(
            'click',
            this.handleClickOutsideBind,
            false
        );

        // Keep tab focus inside nav pane
        this.handleTabKeyBind = this.handleTabKey.bind(this);
        this.wrapper.addEventListener('keydown', this.handleTabKeyBind, true);

        // Hide when escape is pressed
        this.handleEscKeyBind = this.handleEscKey.bind(this);
        this.wrapper.addEventListener('keyup', this.handleEscKeyBind, true);

        this.isShown = true;
    }

    hide(e) {
        if (!this.isShown) {
            return;
        }

        document.querySelector('body').classList.remove('nav-pane-open');

        this.wrapper.removeEventListener(
            'click',
            this.handleClickOutsideBind,
            false
        );

        this.wrapper.removeEventListener(
            'keydown',
            this.handleTabKeyBind,
            false
        );

        this.wrapper.removeEventListener('keyup', this.handleEscKeyBind, false);
        this.handleClickOutsideBind = null;
        this.handleTabKeyBind = null;
        this.handleEscKeyBind = null;

        // set expanded a bit earlier to prevent screen readers from reading expanded=true
        this.opener.setAttribute('aria-expanded', 'false');

        setTimeout(() => {
            this.wrapper.style.display = 'none';
            this.wrapper.setAttribute('aria-hidden', 'true');
            this.opener.focus();
            this.opener = null;
            this.isShown = false;
        }, this.animationDelay);
    }

    handleClickOutside(e) {
        if (e.target !== this.wrapper || !this.isShown) {
            return;
        }

        this.hide();
    }

    handleEscKey(e) {
        if (e.keyCode === 27 && this.isShown) {
            e.preventDefault();
            this.hide();
        }
    }

    handleTabKey(e) {
        // if tab is pressed
        if (e.keyCode === 9) {
            var focusableItemsSelector =
                    'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]',
                focusableItems = this.getAll(focusableItemsSelector),
                focusedItem = document.activeElement,
                numberOfFocusableItems = focusableItems.length,
                focusedItemIndex = Array.from(focusableItems).indexOf(
                    focusedItem
                );

            if (e.shiftKey) {
                //back tab
                // if focused on first item and user preses back-tab, go to the last focusable item
                if (focusedItemIndex === 0) {
                    focusableItems[focusableItems.length - 1].focus();
                    e.preventDefault();
                }
            } else {
                //forward tab
                // if focused on the last item and user preses tab, go to the first focusable item
                if (focusedItemIndex === numberOfFocusableItems - 1) {
                    focusableItems[0].focus();
                    e.preventDefault();
                }
            }
        }
    }

    get wrapper() {
        return this.element;
    }

    get navPane() {
        return this.get('.nav-pane');
    }

    get openers() {
        return Array.from(
            document.querySelectorAll(`[data-target="#${this.element.id}"]`)
        );
    }

    get closers() {
        return this.getAll('[data-dismiss="nav-pane"]');
    }
}

EnhancerApp.register('NavPane', NavPane);
